import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSupabaseUser } from '../contexts/SupabaseUserContext';

const AuthenticatedRoute = ({ children }) => {
  const supabaseUser = useSupabaseUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!supabaseUser) {
      navigate('/login');
    }
  }, [supabaseUser, navigate]);

  return supabaseUser ? children : null;
};

export default AuthenticatedRoute; 